import { ArrowUpRight } from "lucide-react";
import SEO from "../components/SEO";
import ContactForm from "../components/ContactForm";
import { Reveal, Lines } from "../components/Reveal";
import { COMPANY } from "../data/content";

const Contact = () => (
  <>
    <SEO title="Contact | ARCH EXPO" description="Let's discuss your project. Tell us what you are building, where it is located and which services you require." />
    <section className="pt-40 sm:pt-52 pb-16 bg-paper" data-testid="contact-page">
      <div className="container-ax">
        <Reveal>
          <p className="label-tech flex items-center gap-3 mb-8 text-graphite">
            <span className="inline-block w-2 h-2 rounded-full bg-cobalt" />
            Contact — Project enquiry
          </p>
        </Reveal>
        <h1 className="t-h1 text-coal max-w-4xl" data-testid="contact-headline">
          <Lines lines={["Let's discuss", "your project."]} animateOnMount />
        </h1>
      </div>
    </section>
    <section className="bg-paper pb-24 sm:pb-32">
      <div className="container-ax grid grid-cols-12 gap-12">
        <div className="col-span-12 lg:col-span-7">
          <ContactForm />
        </div>
        <aside className="col-span-12 lg:col-span-4 lg:col-start-9" data-testid="contact-aside">
          <Reveal>
            <div className="glass rounded-3xl p-8 mb-6">
              <p className="label-tech text-graphite mb-6">Direct contact</p>
              <p className="text-[15px] text-coal mb-1">Email</p>
              <a href={`mailto:${COMPANY.email}`} data-testid="contact-email" className="link-line text-graphite hover:text-cobalt transition-colors inline-block mb-5">{COMPANY.email}</a>
              <p className="text-[15px] text-coal mb-1">LinkedIn</p>
              <a href={COMPANY.linkedin} target="_blank" rel="noopener noreferrer" data-testid="contact-linkedin" className="link-line inline-flex items-center gap-1 text-graphite hover:text-cobalt transition-colors">
                Arch Expo AG <ArrowUpRight size={13} />
              </a>
            </div>
          </Reveal>
        </aside>
      </div>
    </section>
  </>
);

export default Contact;
